import React from "react";
import { useSelector } from "react-redux";
import { Container, Skeleton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { columns } from "./deliverersHeaders.js";
import { formatCurrency } from "../../../utils/Format.js";
import styles from "./deliverersTableStyles.js";
import NoData from "../../../components/SharedComponents/NoData";

const DeliverersTable = ({ deliverers = [], isLoading, search }) => {
  const navigate = useNavigate();
  const { extraInformation } = useSelector((state) => state.user);
  const isSuperAdmin = extraInformation?.id_role === 5;

  const filteredRows = deliverers.filter((deliveryMen) => {
    const transformedUser = {
      ...deliveryMen,
    };

    return Object.values(transformedUser).some((value) =>
      value.toString().toLowerCase().includes(search.toLowerCase())
    );
  });

  const rows = filteredRows?.map((deliveryMen, index) => {
    const regionNames =
      Array.isArray(deliveryMen.zone_names) && deliveryMen.zone_names.length > 0
        ? deliveryMen.zone_names[0]
        : "Sin región";

    return {
      id: deliveryMen.id_delivery_man,
      name_complete: deliveryMen.name_complete,
      failed_delivered_guides: deliveryMen.failed_delivered_guides,
      pending_guides: deliveryMen.pending_guides,
      delivered_guides: deliveryMen.delivered_guides,
      region: regionNames,
      balance: formatCurrency(deliveryMen.balance),
    };
  });

  const handleRowClick = (params) => {
    navigate(`/repartidores/${params.id}`);
  };

  const tableColumns = [
    ...columns.filter(
      (col) => col.field !== "region" && col.field !== "balance"
    ),
    ...(isSuperAdmin
      ? [
          {
            field: "region",
            headerName: "REGIÓN",
            type: "string",
            width: 100,
            resizable: false,
            sortable: false,
            headerAlign: "left",
            align: "left",
            renderHeader: (params) => <strong>REGIÓN</strong>,
          },
        ]
      : []),
    ...columns.filter((col) => col.field === "balance"),
  ];

  return (
    <Container sx={styles.mainContainer}>
      {isLoading ? (
        <Container sx={styles.skeletonMainContainer}>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={"5%"} height={40} />
            <Skeleton variant="rounded" width={"20%"} height={40} />
            <Skeleton variant="rounded" width={"30%"} height={40} />
            <Skeleton variant="rounded" width={"10%"} height={40} />
            <Skeleton variant="rounded" width={"10%"} height={40} />
            <Skeleton variant="rounded" width={"10%"} height={40} />
            {isSuperAdmin && (
              <Skeleton variant="rounded" width={"10%"} height={40} />
            )}
            <Skeleton variant="rounded" width={"15%"} height={40} />
          </Container>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={"5%"} height={300} />
            <Skeleton variant="rounded" width={"20%"} height={300} />
            <Skeleton variant="rounded" width={"30%"} height={300} />
            <Skeleton variant="rounded" width={"10%"} height={300} />
            <Skeleton variant="rounded" width={"10%"} height={300} />
            <Skeleton variant="rounded" width={"10%"} height={300} />
            {isSuperAdmin && (
              <Skeleton variant="rounded" width={"10%"} height={300} />
            )}
            <Skeleton variant="rounded" width={"15%"} height={300} />
          </Container>
        </Container>
      ) : (
        <DataGrid
          autoHeight
          disableColumnFilter
          rows={rows}
          columns={tableColumns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          getRowHeight={() => "auto"}
          sx={{
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
              py: "8px",
              display: "flex",
              alignItems: "center",
            },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
              py: "15px",
              display: "flex",
              alignItems: "center",
            },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
              py: "22px",
              display: "flex",
              alignItems: "center",
            },
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          localeText={{
            noRowsLabel: <NoData title="No se encontraron repartidores" />,
          }}
          onRowClick={handleRowClick}
        />
      )}
    </Container>
  );
};

export default DeliverersTable;
